/**
 * Generated bundle index. Do not edit.
 */

export * from './element-patch-public-api';
